import projetosRotas from './projetos/ProjetosRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'

export default {
    path: 'apoios',
    name: 'Sgtec_Apoios',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        projetosRotas,
        pagamentosRotas
    ]
}
